import { Directive } from '@angular/core';

@Directive({
  selector: '[app-nav-page-title]',
  host: {
    class: 'prose prose-display-lg font-semibold'
  }
})
export class NavPageTitle {}
